module.exports = "/_next/static/images/umbrellaalt-141833c014df255b3407ae4fc042ef1e.svg";